import { CDSMask } from '@app/utils/cds-mask';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { NaturezaDeAcao } from '@app/models/natureza-de-acao.model';

import { NaturezaDeAcaoService } from '@app/services/natureza-de-acao.service';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';

@Component({
  selector: 'app-natureza-de-acao-form',
  templateUrl: './natureza-de-acao-form.component.html'
})
export class NaturezaDeAcaoFormComponent implements OnInit {

  lstTipoDeAcao: IdDescricao[] = [];
  titulo: string;
  lstErros: string[];
  cdsMask: CDSMask = new CDSMask();
  naturezaDeAcao: NaturezaDeAcao = new NaturezaDeAcao();
  aguardandoSolicitacao: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private naturezaDeAcaoService: NaturezaDeAcaoService,
    private consultasService: ConsultasService,
  ) {
    this.naturezaDeAcao.TipoDeAcaoId = null;
    this.naturezaDeAcao.Ativo = true;
  }

  ngOnInit() {
    this.consultasService.consultar('TIPODEACAO').toPromise().then(data => this.lstTipoDeAcao = data);

    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Natureza de Ação' : 'Nova Natureza de Ação';

      // novo
      if (!id) {
        this.naturezaDeAcao.ValorPadraoPorcentualCliente = 70;
        this.naturezaDeAcao.ValorPardaoPorcentualEscritorio = 30;
        return;

      }
      // editar
      this.naturezaDeAcaoService.obterPorId(id).toPromise().then(
        data => {this.naturezaDeAcao = data;},
        () => this.router.navigate(['./configuracoes/natureza-de-acao'])
      );

    });
  }

  completaCliente() {
    this.sanitizar();
    this.naturezaDeAcao.ValorPadraoPorcentualCliente = Number((100 - this.naturezaDeAcao.ValorPardaoPorcentualEscritorio).toFixed(2));
  }

  completaEscritorio() {
    this.sanitizar();
    this.naturezaDeAcao.ValorPardaoPorcentualEscritorio = Number((100 - this.naturezaDeAcao.ValorPadraoPorcentualCliente).toFixed(2));
  }
  sanitizar(): void {
    if(this.naturezaDeAcao.ValorPadraoPorcentualCliente.toString().indexOf(','))
      this.naturezaDeAcao.ValorPadraoPorcentualCliente = Number(this.naturezaDeAcao.ValorPadraoPorcentualCliente.toString().replace(',', '.'));
    if( this.naturezaDeAcao.ValorPardaoPorcentualEscritorio.toString().indexOf(','))
    this.naturezaDeAcao.ValorPardaoPorcentualEscritorio = Number(this.naturezaDeAcao.ValorPardaoPorcentualEscritorio.toString().replace(',', '.'));
  }
  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.naturezaDeAcaoService.gravar(this.naturezaDeAcao).toPromise().then(
      () => this.router.navigate(['./configuracoes/natureza-de-acao']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
